const { REACT_APP_PUBLIC_URL } = process.env;
const versionApi = '/api/v1';

export const API_URL = REACT_APP_PUBLIC_URL
  ? REACT_APP_PUBLIC_URL + versionApi
  : 'https://podarok.megafon.ru/api/v1';

export enum AppRoute {
  ROOT = '/',
  OFFER = '/offer',
  PROMOCODE = '/gift/activate',
  ORDERS = '/orders',
  LEGAL = '/storage/docs/legal.pdf',
}

export enum Error {
  UNAUTHORIZED = 401,
}

/** Тексты ошибок */
export enum ErrorMessage {
  COMMON_ERROR = 'Что-то пошло не так :(',
  NOT_FOUND = 'Страница не найдена',
}

export const KEY_STORAGE_PROMOCODE = 'promocode';
